import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import draftLocked from "../../../public/BP_resources/images/icon//locked.svg";
import unlockedGrey from "../../../public/BP_resources/images/icon/unlocked-grey.svg";
import lockedGrey from "../../../public/BP_resources/images/icon/addcheck.svg";
import locked from "../../../public/BP_resources/images/icon/addcheck.svg";
import unlocked from "../../../public/BP_resources/images/icon/unlocked.svg";
import CheckAlreadyRequestedModal from "../CostDashboard/CheckAlreadyRequested";
import { currencyFormat } from "../../Utils/helper";
import SettlementErrorModal from "../Modals/SettlementErrorModal";
import SettlementNoCheckModal from "../Modals/SettlementNoCheckModal";
import SettlementCheckRequest from "../Modals/SettlementCheckRequest";
import EditOtherLiens from "../Modals/EditOtherLiens";
import GenericSettlementAddPopup from "../Modals/GenericSettlementAddPopup";

import updateLockSettleAmount from "./common/updateLockSettleAmount";
import AllLockSettle from "./common/AllLockSettle";
import updateLockSettleValue from "./common/updateLockSettleValue";
import ChequeUpload from "./ChequeUpload";
import SectionActionBar from "./SectionActionBar";
import CopyValueSettlement from "./common/CopyValueSettlement";
import updateRightColumnValue from "./common/updateRightColumnValue";
import SettlementEmptyMessage from "./SettlementEmptyMessage";
import SettlementCheckDetails from "./common/SettlementCheckDetails";
import SettlementCurrencyInput from "./common/SettlementCurrencyInput";
import { hasNonZeroSettlementAmount, hasSettlementCheck } from "./common/settlementCheckGuards";

const OtherLiensTable = ({ otherLiensObj, clientProceeds, settlementObjProps }) => {
  const [, setIsHovered] = useState({ id: -1, value: false });
  const [showSettlementPopup, setShowSettlementPopup] = useState(false);
  const { updateClientProceedsState } = clientProceeds;
  const [errorMsg, _setMsgError] = useState("");
  const lockAllLiens = (bType, boolVal) => {
    AllLockSettle("other_lien", bType, boolVal);
    if (bType === "draft1") {
      setOtherLiensLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isDraftLocked: hasSettlementCheck(row) ? row.isDraftLocked : boolVal === "true",
        }))
      );
    } else {
      setOtherLiensLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isFinalLocked: hasSettlementCheck(row) ? row.isFinalLocked : boolVal === "true",
        }))
      );
    }
  };
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );

  const [showCheckRequestModal, setCheckRequestModal] = useState(false);
  const handleCheckRequestClose = () => setCheckRequestModal(false);

  const [showNoCheckModal, setNoCheckModal] = useState(false);
  const handleNoCheckClose = () => setNoCheckModal(false);
  const handleNoCheckShow = () => setNoCheckModal(true);
  const [checkAlreadyRequested, setCheckAlreadyRequested] = useState(false);
  const handleCheckAlreadyRequestedClose = () => setCheckAlreadyRequested(false);
  const handleCheckedRowClick = (event) => {
    event?.stopPropagation();
    setCheckAlreadyRequested(true);
  };

  const handleDraftLockChange = (id, sectionName, e) => {
    e.stopPropagation();
    if (sectionName === "other_lien") {
      const lock = otherLiensLocks.find((row) => row.id === id);
      if (hasSettlementCheck(lock)) {
        handleCheckedRowClick(e);
        return;
      }
      updateLockSettleValue(id, "other_lien", "draft1");
      setOtherLiensLocks((prevStates) =>
        prevStates.map((row) =>
          row.id === id ? { ...row, isDraftLocked: !row.isDraftLocked } : row
        )
      );
    }
  };

  const handleFinalLockChange = (id, sectionName, e) => {
    e.stopPropagation();
    if (sectionName === "other_lien") {
      const lock = otherLiensLocks.find((row) => row.id === id);
      if (hasSettlementCheck(lock)) {
        handleCheckedRowClick(e);
        return;
      }
      updateLockSettleValue(id, "other_lien", "final");
      setOtherLiensLocks((prevStates) =>
        prevStates.map((row) =>
          row.id === id ? { ...row, isFinalLocked: !row.isFinalLocked } : row
        )
      );
    }
  };
  const {
    otherLiens,
    otherLiensLocks,
    setOtherLiensLocks,
    otherLiensLocksValues,
    setOtherLiensLocksValues,
    otherLienFinalAmount,

    showErrorLeinModal,
    handleLienErrorShow: _handleLienErrorShow,
    handleLienErrorClose,
    handleEditOtherLienClose,
    handleEditOtherLienShow,
    showEditOtherLien,
    updateOtherLiensStates,
  } = otherLiensObj;
  const [currentOtherLien, setCurrentOtherLien] = useState(otherLiens[0] || {});
  const getInputSum = (className) =>
    [...document.querySelectorAll(`.${className}`)].reduce((acc, input) => {
      const val = input.getAttribute("data-value") || "0";
      const num = parseFloat(val);

      return !isNaN(num) ? acc + num : acc;
    }, 0);

  const [colSpanValue, setColSpanValue] = useState(
    document.documentElement.clientWidth < 2100 ? 5 : 6
  );
  useEffect(() => {
    const handleResize = () => {
      setColSpanValue(document.documentElement.clientWidth < 2100 ? 5 : 6);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div className="m-t-5">
        <SectionActionBar sectionName={"Other Liens"} />
        <div className="table--no-card rounded-0 border-0 w-100">
          <table className="table table-borderless table-striped table-earning settlement-table">
            <thead>
              <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                <th className="" />
                <th className="td-autosize text-center first-col">Name</th>
                <th className="text-end dollar-amount-value med-bill-width td-autosize">
                  Original
                </th>
                <th className="text-end dollar-amount-value med-bill-width td-autosize hide-table-data" />
                <th className="text-end dollar-amount-value med-bill-width td-autosize">
                  Reduction
                </th>
                {/* <th className="text-end dollar-amount-value med-bill-width td-autosize">Final Lien</th> */}
                <th className="" />
                <th
                  className={`height-25 text-end fw-bold td-autosize ${otherLiensLocks?.some((lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                  // style={{color:"var(--primary-25) !important"}}
                  onClick={() => {
                    const draftLockCheck = otherLiensLocks?.some(
                      (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                    );
                    if (draftLockCheck) {
                      otherLiensLocks?.forEach((lien, index) => {
                        if (!lien.isDraftLocked && !hasSettlementCheck(lien)) {
                          updateRightColumnValue(
                            lien.isDraftLocked,
                            lien.isFinalLocked,
                            setOtherLiensLocks,
                            "other-draft",
                            lien.id,
                            otherLiensLocksValues,
                            setOtherLiensLocksValues,
                            "other_lien",
                            "draft1",
                            otherLiens[index]?.amount
                          );
                        }
                      });
                      updateOtherLiensStates();
                      updateClientProceedsState();
                    }
                  }}
                >
                  <span className="d-flex align-items-center justify-content-end position-relative center-val-div">
                    {otherLiensLocks?.some(
                      (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                    ) && <CopyValueSettlement />}
                    Final Lien
                  </span>
                </th>
                <th
                  className={`s-draft text-end ${otherLiensLocks?.some((lock) => lock.isDraftLocked && !lock.isFinalLocked) ? "cursor-pointer" : ""}`}
                  style={{ color: "var(--primary-25) !important" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const finalLockCheck = otherLiensLocks?.some(
                      (lock) => lock.isDraftLocked && !lock.isFinalLocked
                    );
                    if (finalLockCheck) {
                      otherLiensLocks?.forEach((lien) => {
                        if (
                          lien.isDraftLocked &&
                          !lien.isFinalLocked &&
                          !hasSettlementCheck(lien)
                        ) {
                          updateRightColumnValue(
                            lien.isDraftLocked,
                            lien.isFinalLocked,
                            setOtherLiensLocks,
                            "other-final",
                            lien.id,
                            otherLiensLocksValues,
                            setOtherLiensLocksValues,
                            "other_lien",
                            "final",
                            lien.isDraftAmount
                          );
                        }
                      });
                      updateClientProceedsState();
                    }
                  }}
                >
                  <div className="central-header-div d-flex justify-content-between align-items-center height-25">
                    <div className="d-flex align-items-center position-relative">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19 lock-icon"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllLiens("draft1", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19 lock-icon"
                        alt="lock-icon"
                        src={draftLocked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllLiens("draft1", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span
                      className="d-flex align-items-center justify-content-end position-relative center-val-div draft-central-div"
                      style={{ paddingRight: "2px" }}
                    >
                      {otherLiensLocks?.some(
                        (lock) =>
                          lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                      ) && <CopyValueSettlement />}
                      <span className="position-absolute right-0">Draft</span>
                    </span>
                  </div>
                </th>
                <th className="s-final text-end" style={{ color: "var(--primary-25) !important" }}>
                  <div className="d-flex justify-content-between align-items-center height-25">
                    <div className="d-flex align-items-center">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllLiens("final", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19"
                        alt="lock-icon"
                        src={locked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllLiens("final", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span style={{ paddingRight: "2px" }}>Final</span>
                  </div>
                </th>
                <th className="s-verify" />
                <th
                  className="td-autosize check-request--btn-settle text-center"
                  style={{ color: "var(--primary-25) !important" }}
                >
                  Check
                </th>
              </tr>
            </thead>
            <tbody id="body-table">
              {otherLiens?.length === 0 && (
                <tr id="cost-settle-row" className="add-btn-row cursor-default padding-tr-0">
                  <td className="text=center cursor-pointer" colSpan={colSpanValue + 5}>
                    <SettlementEmptyMessage
                      name="OTHER LIENS"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSettlementPopup(true);
                      }}
                    />
                  </td>
                </tr>
              )}
              {otherLiens?.length > 0 &&
                otherLiens?.map((lien, index) => (
                  <tr
                    className="cursor-default"
                    onClick={() => {
                      if (hasSettlementCheck(otherLiensLocks[index])) {
                        // handleCheckedRowClick(e);
                        return;
                      }
                      setCurrentOtherLien(lien);
                      handleEditOtherLienShow();
                    }}
                  >
                    <td className="">{index + 1}</td>
                    <td className="first-col text-start">{lien?.name}</td>
                    <td
                      className="text-end monospace-font dollar-amount-value med-bill-width td-autosize"
                      data-value={lien?.original}
                    >
                      {currencyFormat(lien?.original)}
                    </td>
                    <td className="text-end monospace-font dollar-amount-value med-bill-width td-autosize hide-table-data" />
                    <td
                      className="text-end monospace-font dollar-amount-value med-bill-width td-autosize"
                      data-value={lien?.reduction}
                    >
                      {currencyFormat(-Math.abs(lien?.reduction))}
                    </td>
                    {/* <td className="text-end monospace-font dollar-amount-value med-bill-width td-autosize" data-value={lien?.amount}>{currencyFormat(Math.abs(lien?.amount))}</td> */}
                    <td className="" onClick={(e) => e.stopPropagation()} />
                    <td
                      className={`monospace-font  dollar-amount-value text-end ${!otherLiensLocks[index].isDraftLocked && !hasSettlementCheck(otherLiensLocks[index]) ? "cursor-pointer" : ""}`}
                      data-value={lien?.amount}
                    >
                      <span
                        className={`d-flex align-items-center ${!otherLiensLocks[index].isDraftLocked && !hasSettlementCheck(otherLiensLocks[index]) ? "justify-content-between cursor-pointer" : "justify-content-end"} align-items-center position-relative center-val-div`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (hasSettlementCheck(otherLiensLocks[index])) {
                            handleCheckedRowClick(e);
                            return;
                          }
                          updateRightColumnValue(
                            otherLiensLocks[index].isDraftLocked,
                            otherLiensLocks[index].isFinalLocked,
                            setOtherLiensLocks,
                            "other-draft",
                            lien.id,
                            otherLiensLocksValues,
                            setOtherLiensLocksValues,
                            "other_lien",
                            "draft1",
                            lien?.amount
                          );
                          updateOtherLiensStates();
                          updateClientProceedsState();
                        }}
                      >
                        {!otherLiensLocks[index].isDraftLocked &&
                          !hasSettlementCheck(otherLiensLocks[index]) && <CopyValueSettlement />}
                        {currencyFormat(lien?.amount)}
                      </span>
                    </td>
                    <td
                      className="s-draft text-end"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (hasSettlementCheck(otherLiensLocks[index])) {
                          handleCheckedRowClick(e);
                          return;
                        }
                        updateRightColumnValue(
                          otherLiensLocks[index].isDraftLocked,
                          otherLiensLocks[index].isFinalLocked,
                          setOtherLiensLocks,
                          "other-final",
                          lien.id,
                          otherLiensLocksValues,
                          setOtherLiensLocksValues,
                          "other_lien",
                          "final",
                          otherLiensLocks[index].isDraftAmount
                        );
                        updateOtherLiensStates();
                        updateClientProceedsState();
                      }}
                    >
                      <div
                        className={
                          "monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                        }
                      >
                        <span>
                          {!hasSettlementCheck(otherLiensLocks[index]) && (
                            <img
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDraftLockChange(lien.id, "other_lien", e);
                              }}
                              id="lock-image"
                              className="ic ic-15"
                              src={otherLiensLocks[index].isDraftLocked ? draftLocked : unlocked}
                              alt="lock-icon"
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span>
                        <SettlementCurrencyInput
                          id="lock-input"
                          className={`${otherLiensLocks[index].isDraftLocked && !otherLiensLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font other-draft-${lien?.id} text-end other-draft dollar-amount-value ${
                            otherLiensLocks[index].isDraftLocked ? "locked-input" : "unlock-input"
                          }`}
                          value={lien?.draft1}
                          readOnly={
                            otherLiensLocks[index].isDraftLocked ||
                            hasSettlementCheck(otherLiensLocks[index])
                          }
                          onClick={(e) => {
                            if (hasSettlementCheck(otherLiensLocks[index])) {
                              handleCheckedRowClick(e);
                              return;
                            }
                            e.target.focus(); // Ensure input gets focus
                          }}
                          onLocalChange={({ dataValue }) => {
                            if (hasSettlementCheck(otherLiensLocks[index])) return;
                            setOtherLiensLocks((prevStates) =>
                              prevStates.map((row) =>
                                row.id === lien?.id ? { ...row, isDraftAmount: dataValue } : row
                              )
                            );
                            const sum = getInputSum("other-draft");
                            setOtherLiensLocksValues((prevValues) => [sum, prevValues[1]]);
                          }}
                          onDebouncedCommit={async ({ submitValue }) => {
                            if (hasSettlementCheck(otherLiensLocks[index])) return;
                            await updateLockSettleAmount(
                              lien?.id,
                              "other_lien",
                              "draft1",
                              submitValue
                            );
                            updateOtherLiensStates();
                            updateClientProceedsState();
                          }}
                          onMouseEnter={(e) => {
                            if (
                              otherLiensLocks[index].isDraftLocked &&
                              !otherLiensLocks[index].isFinalLocked &&
                              !hasSettlementCheck(otherLiensLocks[index])
                            ) {
                              const container = e.currentTarget.closest(".center-val-div");
                              const lockImg = container?.querySelector("#lock-image");
                              const copyElement = container?.querySelector(
                                ".copy-centered-draft, .copy-centered-final, .copy-centered"
                              );
                              if (lockImg) {
                                lockImg.style.opacity = 0;
                                lockImg.style.zIndex = 0;
                              }
                              if (copyElement) {
                                copyElement.style.opacity = 1;
                                copyElement.style.zIndex = 1;
                                copyElement.style.cursor = "pointer";
                                copyElement.style.display = "flex";
                              }
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (
                              otherLiensLocks[index].isDraftLocked &&
                              !otherLiensLocks[index].isFinalLocked
                            ) {
                              const container = e.currentTarget.closest(".center-val-div");
                              const lockImg = container?.querySelector("#lock-image");
                              const copyElement = container?.querySelector(
                                ".copy-centered-draft, .copy-centered-final, .copy-centered"
                              );
                              if (lockImg) {
                                lockImg.style.opacity = 1;
                                lockImg.style.zIndex = 1;
                              }
                              if (copyElement) {
                                copyElement.style.opacity = 0;
                                copyElement.style.zIndex = 0;
                                copyElement.style.cursor = "initial";
                                copyElement.style.display = "none";
                              }
                            }
                          }}
                          style={{ zIndex: 2 }}
                        />
                        {otherLiensLocks[index].isDraftLocked &&
                          !otherLiensLocks[index].isFinalLocked &&
                          !hasSettlementCheck(otherLiensLocks[index]) && (
                            <CopyValueSettlement draft={true} />
                          )}
                      </div>
                    </td>
                    <td className="s-final" onClick={(e) => e.stopPropagation()}>
                      <div
                        // onMouseEnter={() => setIsHovered({ id: lien?.id, value: true })}
                        // onMouseLeave={() => setIsHovered({ id: lien?.id, value: false })}
                        className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                      >
                        <span>
                          {!hasSettlementCheck(otherLiensLocks[index]) && (
                            <img
                              onClick={(e) => {
                                e.stopPropagation();
                                handleFinalLockChange(lien?.id, "other_lien", e);
                              }}
                              id="lock-image"
                              className={`ic ic-15 ${otherLiensLocks[index].checkID?.check_sent ? "invisible" : ""} `}
                              src={
                                otherLiensLocks[index].isFinalLocked
                                  ? otherLiensLocks[index].checkID?.check_sent
                                    ? lockedGrey
                                    : draftLocked
                                  : otherLiensLocks[index].checkID?.check_sent
                                    ? unlockedGrey
                                    : unlocked
                              }
                              alt="lock-icon"
                              style={{ cursor: "pointer" }}
                              onMouseEnter={() => setIsHovered({ id: lien?.id, value: false })}
                              onMouseLeave={() => setIsHovered({ id: lien?.id, value: true })}
                            />
                          )}
                        </span>
                        <SettlementCurrencyInput
                          id="lock-input"
                          className={`${!otherLiensLocks[index].checkID && otherLiensLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font other-final-${lien?.id} text-end other-final dollar-amount-value ${
                            otherLiensLocks[index].isFinalLocked ? "locked-input" : "unlock-input"
                          }`}
                          value={lien?.final}
                          readOnly={
                            otherLiensLocks[index].isFinalLocked ||
                            hasSettlementCheck(otherLiensLocks[index])
                          }
                          onClick={async (e) => {
                            e.stopPropagation();
                            e.target.focus(); // Ensure input gets focus
                            if (hasSettlementCheck(otherLiensLocks[index])) {
                              handleCheckedRowClick(e);
                              return;
                            }
                          }}
                          onLocalChange={({ dataValue }) => {
                            if (hasSettlementCheck(otherLiensLocks[index])) return;
                            setOtherLiensLocks((prevStates) =>
                              prevStates.map((row) =>
                                row.id === lien?.id ? { ...row, isFinalAmount: dataValue } : row
                              )
                            );
                            const sum = getInputSum("other-final");
                            setOtherLiensLocksValues((prevValues) => [prevValues[0], sum]);
                          }}
                          onDebouncedCommit={async ({ submitValue }) => {
                            if (hasSettlementCheck(otherLiensLocks[index])) return;
                            await updateLockSettleAmount(
                              lien?.id,
                              "other_lien",
                              "final",
                              submitValue
                            );
                            updateOtherLiensStates();
                            updateClientProceedsState();
                          }}
                        />
                        {!otherLiensLocks[index].checkID &&
                          otherLiensLocks[index].isFinalLocked && (
                            <CopyValueSettlement draft={true} final={true} />
                          )}
                      </div>
                    </td>
                    <td className="s-verify" onClick={(e) => e.stopPropagation()}>
                      <ChequeUpload
                        entity={lien}
                        panel={"other_lien"}
                        pageId={page_id_click_record}
                        documentType="verify"
                        updateStates={updateOtherLiensStates}
                        handleNoCheckShow={handleNoCheckShow}
                      />
                    </td>
                    <td
                      className="td-autosize text-center d-flex"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div
                        className={`${otherLiensLocks[index]?.checkID?.cheque_number ? "check-class" : "d-flex justify-content-center"} `}
                      >
                        {!otherLiensLocks[index].checkID &&
                        otherLiensLocks[index].isFinalLocked &&
                        hasNonZeroSettlementAmount(otherLiensLocks[index].isFinalAmount) ? (
                          <div className="d-flex align-items-center justify-content-center">
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                if (otherLiensLocks[index].isFinalLocked) {
                                  setCurrentOtherLien({
                                    ...lien,
                                    final: otherLiensLocks[index].isFinalAmount,
                                  });
                                  setCheckRequestModal(true);
                                }
                              }}
                              className="settle-check-request-btn btn"
                              id="nomargin"
                              style={{
                                color: "white",
                                fontWeight: "600",
                                background: "#009900",
                              }}
                            >
                              <p className={"font-weight-semibold"}>Request Check</p>
                            </div>
                          </div>
                        ) : (
                          <SettlementCheckDetails
                            entity={lien}
                            check={otherLiensLocks[index].checkID}
                            pageId={page_id_click_record}
                            updateStates={updateOtherLiensStates}
                            handleNoCheckShow={handleNoCheckShow}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              {otherLiens?.length > 0 && (
                <tr className="cursor-default">
                  <td />
                  <td className="height-25 text-capitalize text-end" colSpan={colSpanValue}>
                    <span className="whitespace-SETTLE primary-clr-25 m-r-5">
                      Total Other Liens:{" "}
                    </span>
                    <p
                      className="d-inline-flex align-items-center height-25 monospace-font text-end fw-bold dollar-amount-value"
                      data-value={otherLienFinalAmount || 0.0}
                    >
                      {currencyFormat(otherLienFinalAmount || 0.0)}
                    </p>
                  </td>
                  <td
                    className="s-draft text-end monospace-font"
                    data-value={otherLiensLocksValues[0] || 0.0}
                  >
                    <span
                      style={{ paddingRight: "2px" }}
                      data-value={otherLiensLocksValues[0] || 0.0}
                      className="dollar-amount-value"
                    >
                      {currencyFormat(otherLiensLocksValues[0] || 0.0)}
                    </span>
                  </td>
                  <td
                    className="s-final text-end monospace-font"
                    data-value={otherLiensLocksValues[1] || 0.0}
                  >
                    <span
                      style={{ paddingRight: "2px" }}
                      data-value={otherLiensLocksValues[1] || 0.0}
                      className="dollar-amount-value"
                    >
                      {currencyFormat(otherLiensLocksValues[1] || 0.0)}
                    </span>
                  </td>
                  <td className="s-verify" />
                  <td className="td-autosize  text-center" />
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showEditOtherLien && (
        <EditOtherLiens
          handleClose={handleEditOtherLienClose}
          lien={currentOtherLien}
          show={showEditOtherLien}
          updateLienStates={updateOtherLiensStates}
          updateClientProceedStates={updateClientProceedsState}
        />
      )}
      {showSettlementPopup && (
        <GenericSettlementAddPopup
          show={showSettlementPopup}
          handleClose={() => {
            setShowSettlementPopup(false);
          }}
          _initialLabel={"Other Liens"}
          {...settlementObjProps}
        />
      )}
      {showErrorLeinModal && (
        <SettlementErrorModal
          show={showErrorLeinModal}
          handleClose={handleLienErrorClose}
          errorMsg={errorMsg}
          updateStates={updateOtherLiensStates}
        />
      )}
      {showNoCheckModal && (
        <SettlementNoCheckModal show={showNoCheckModal} handleClose={handleNoCheckClose} />
      )}
      {checkAlreadyRequested && (
        <CheckAlreadyRequestedModal
          show={checkAlreadyRequested}
          hideModal={handleCheckAlreadyRequestedClose}
        />
      )}
      {showCheckRequestModal && (
        <SettlementCheckRequest
          show={showCheckRequestModal}
          handleClose={handleCheckRequestClose}
          finalAmount={currentOtherLien?.final}
          panelLabel={"OtherLiens"}
          panelName={"other_lien"}
          contact_obj={currentOtherLien?.lien_contact}
          panelEntity={currentOtherLien}
          updateStates={() => {
            updateOtherLiensStates();
            updateClientProceedsState();
          }}
        />
      )}
    </>
  );
};

export default OtherLiensTable;
